import { render, staticRenderFns } from "./ActiveBodyguardServicePage.vue?vue&type=template&id=b06d19c0"
import script from "./ActiveBodyguardServicePage.vue?vue&type=script&lang=js"
export * from "./ActiveBodyguardServicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports